import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { typeAlert, position, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import showToast from "../../../../services/toast";
export var AuditPageHeader = function (props) {
    return (_jsx(_Fragment, { children: props.seeToast.show &&
            showToast(position.topRight, props.seeToast.type, props.seeToast.message, function () {
                props.setSeeToast({ show: false, message: "", type: typeAlert.success });
            }) }));
};
